import { $getRoot } from 'lexical';
import { cloneDeep, mapValues } from 'lodash';
import * as Models from 'models';
import { isTextComponent } from 'utils/entityType';
import { toJS } from 'utils/immutable';
import { formatProjectMetadataDates } from 'utils/projectMetadata/formatProjectMetadataDates';
import { createLexicalTextEditor } from '../editors/LexicalTextEditor';
import { $isProjectMetadataTokenNode } from '../nodes/ProjectMetadataTokenNode';

function $updateProjectMetadataTokens(metadata: Record<string, string>): void {
  const root = $getRoot();

  root.getAllTextNodes().filter($isProjectMetadataTokenNode).forEach((node) => {
    const value = metadata[node.getMetadataKey()] ?? '';
    node.setValue(value);
  });
}

export function updateProjectMetadataTokensOnComponent(
  component: Models.TextComponent,
  metadata: Record<string, string>,
): Models.TextComponent {
  const { lexicalState } = component;
  if (!lexicalState) {
    return component;
  }

  const editor = createLexicalTextEditor(lexicalState);
  editor.update(() => {
    $updateProjectMetadataTokens(metadata);
  }, { discrete: true });
  const updatedLexicalState = JSON.stringify(editor.getEditorState());

  if (lexicalState === updatedLexicalState) {
    return component;
  }

  const updatedComponent = cloneDeep(component);
  updatedComponent.lexicalState = updatedLexicalState;

  return updatedComponent;
}

export function updateProjectMetadataTokens(
  documents: Models.CombinedDocuments,
  rootDocument: Models.RootDocument,
): Models.CombinedDocuments {
  const metadata = formatProjectMetadataDates(toJS(rootDocument));

  return mapValues(documents, (document) => {
    if (isTextComponent(document)) {
      return updateProjectMetadataTokensOnComponent(document, metadata);
    }

    return document;
  });
}
